import React from 'react';

const WorkflowTab = () => {
  return <div>Workflow Settings go here</div>;
}

export default WorkflowTab;
